var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormCustomerGroup',{attrs:{"is-submitting":_vm.create.isCreating},on:{"onConfirm":_vm.handleConfirm}})}
var staticRenderFns = []

export { render, staticRenderFns }